import React from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import RentalPlan from '../../helpers/rental_plan'
import styles from '../../../assets/stylesheets/pages/cart/lenscap.module.scss'
import { Button, Modal } from 'lensrentals-components'
import lenscap from '../../../assets/images/lr-lenscap.svg'
import Table from './table'

export default class Lenscap extends React.Component {
  constructor() {
    super()
    this.handleAddAllInsurance = this.handleAddAllInsurance.bind(this)
    this.handleRemoveAllInsurance = this.handleRemoveAllInsurance.bind(this)
  }

  handleAddAllInsurance = event => {
    // don't submit the form with this button
    event.preventDefault()

    const newItems = Object.values(this.props.cartPlan.cartObject).map(item => {
      return item.withProtectionUpdated('LENSCAP_PLUS')
    })

    const newPlan = this.props.cartPlan.withItemsUpdated(newItems)
    newPlan.fullInsuranceAdded = true

    this.props.updateCartPlan(newPlan)
  }

  handleRemoveAllInsurance = event => {
    // don't submit the form with this button
    event.preventDefault()

    const newItems = Object.values(this.props.cartPlan.cartObject).map(item => {
      return item.withProtectionUpdated('none')
    })

    this.props.updateCartPlan(this.props.cartPlan.withItemsUpdated(newItems))
  }

  render() {
    const {
      showLenscapModal,
      toggleLenscapModal,
      cartPlan: {
        additionalAmountTillFullInsurance,
        canAddFullInsurance,
        insurancePrice
      }
    } = this.props

    return (
      <section className={cx('lenscap-plus', styles.lenscap)}>
        <img className={styles.lenscap__image} src={lenscap} alt='Lenscap Plus' />
        <div className={styles.lenscap__text}>
          <header>
            <h2>Lenscap Plus</h2>
          </header>
          <p>
            Lenscap Plus is comprehensive protection plan for your order. It covers a wide variety of damage and even theft.
          </p>
        </div>
        <Button
          className={cx('lenscap-button', 'add-on-action-button', styles.lenscap__button)}
          color='confirm'
          onClick={toggleLenscapModal}
          type='button'
          data-waiver-modal
        >
          Learn More
        </Button>

        <Modal
          id='insuranceModal'
          size='medium'
          show={showLenscapModal}
          toggleShow={toggleLenscapModal}
        >
          <Modal.Title>
            Insurance Liability and Coverage List
          </Modal.Title>

          <Modal.Content>
            <Table />

            <small className='promo-modal__disclaimer'>
              <span>
                * Liability limited to maximum of $100,000. Amounts in excess of $100,000 are 100% liable. For full terms and conditions
              </span>
              <a href='/lenscap'> please see our FAQ</a>
            </small>
          </Modal.Content>

          <Modal.Actions>
            <Button
              className={cx('add-lenscap-to-order', !canAddFullInsurance && styles['button--hidden'])}
              color='confirm'
              onClick={this.handleAddAllInsurance}
              type='button'
            >
              COVER ORDER {additionalAmountTillFullInsurance}
            </Button>

            <Button
              className={cx('remove-lenscap-from-order', insurancePrice === '$0.00' && styles['button--hidden'])}
              color='danger'
              onClick={this.handleRemoveAllInsurance}
              type='button'
            >
              REMOVE LENSCAP FROM ORDER
            </Button>
          </Modal.Actions>
        </Modal>
      </section>
    )
  }
}

Lenscap.defaultProps = {
  showLenscapModal: false
}

Lenscap.propTypes = {
  cartPlan: PropTypes.instanceOf(RentalPlan).isRequired,
  showLenscapModal: PropTypes.bool,
  toggleLenscapModal: PropTypes.func.isRequired,
  updateCartPlan: PropTypes.func.isRequired
}
